
<template>
  <div>
    <el-dialog :title="$t('jobManagementV2.editor')"
      @close="closeDialog"
      :visible.sync="dialogVisible"
      custom-class="zhDialog">
      <div class="body-topLine"></div>
      <el-form :model="ruleForm"
        :rules="rules"
        :hide-required-asterisk="true"
        ref="ruleForm"
        label-position="top"
        class="demo-ruleForm">
        <el-form-item :label="$t('jobManagementV2.jobName')"
          class="name"
          prop="name">
          <el-input v-model.trim="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('projectV2.langDesc')"
          class="langdesc"
          required>
          <el-col :span="11">
            <el-form-item>
              <el-select v-model="ruleForm.sourceLang"
                :disabled="true"
                :placeholder="$t('jobManagementV2.targetLangNoData')">
                <el-option v-for="(item, index) in sourceLangNameOpt"
                  :key="index"
                  :label="$i18n.locale === 'zh' ? item.sourceLangName:$langCase[item.sourceLang]"
                  :value="item.sourceLang">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="langdescBox"></div>
          </el-col>
          <el-col :span="11">
            <el-form-item>
              <el-select v-model="ruleForm.targetLang"
                :disabled="true"
                :placeholder="$t('jobManagementV2.sourceLangNoData')">
                <el-option v-for="(item, index) in targetLangNameOpt"
                  :key="index"
                  :label="$i18n.locale === 'zh' ?item.targetLangName:$langCase[item.targetLang]"
                  :value="item.targetLang">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('projectV2.domain')"
          class="domain">
          <el-select v-model="ruleForm.domainCode"
            :disabled="true"
            :placeholder="$t('jobManagementV2.domainNoData')">
            <el-option v-for="(item, index) in domainList"
              :key="index"
              :label="$i18n.locale === 'zh' ?item.name:$domainCase[ruleForm.domainCode]"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('projectV2.limitTime')"
          class="deliverytime"
          prop="deliverytime">
          <el-date-picker v-model="ruleForm.deliveryTime"
            :clearable="false"
            prefix-icon="data"
            :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            :disabled="deadline<new Date()"
            type="datetime"
            :placeholder="$t('jobManagementV2.selectText')">
          </el-date-picker>
          <i class="date-i"></i>
        </el-form-item>
      </el-form>
      <el-upload class="upload-demo"
        v-if="this.areaHidden"
        drag
        ref="upload"
        action
        :show-file-list="false"
        :file-list="fileList"
        :accept="$supportFileSuffixes().acceptStr"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :http-request="uploadSectionFile"
        :on-change="uploadChange"
        :before-upload="beforeUploadFile">
        <div class="el-upload__text"
          v-if="!this.fileList.length">
          <div>{{ $t("jobManagementV2.uploadText") }}</div>
          <div>{{ $t("jobManagementV2.supportedFormats") }}：<em>{{$supportFileSuffixes().tip}}</em></div>
        </div>
        <div class="progress"
          v-if="this.fileList.length">
          <el-progress :percentage="this.fileList[0].percentage"
            :format="format"></el-progress>
        </div>
      </el-upload>
      <div class="file-info"
        v-else>
        <div class="job-info">
          <img src="./assets/images/delete.png"
            @click="deleteJob()"
            alt="" />
          <p class="file-name-title">
            <span>{{ $t("jobManagementV2.fileName") }}：</span>
            <el-tooltip class="item"
              effect="dark"
              :content="fileInfo.name"
              placement="top">
              <span class="file-name">{{ fileInfo.name }}</span>
            </el-tooltip>
          </p>
          <p class="file-size">
            {{ $t("jobManagementV2.fileSize") }}：{{
              (fileInfo.fileSize / 1024).toFixed(2)
            }}KB
          </p>
          <p class="vaild">
            {{ $t("jobManagementV2.wordNumber") }}：{{ fileInfo.sourceWordNum }}
          </p>
          <p class="sentence">
            {{ $t("jobManagementV2.sentenceNumber") }}：{{ fileInfo.sentCount }}
          </p>
        </div>
      </div>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="()=>{dialogVisible = false;this.$refs.ruleForm.clearValidate()}">{{
          $t("projectV2.cancel")
        }}</el-button>
        <el-button type="primary"
          v-preventReClick
          @click="createJob('ruleForm')">{{ $t("projectV2.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { getUploadSign } from "../../../../services/newProjectApi";
import { queryLanguageList } from "../../../../services/createJob";
import {
  queryDomainList,
  queryFile,
  queryProjectTermMemoryList,
  updateProject,
} from "../../../../services/jobManagement";

export default {
  name: "CatWebPcIndex",
  props: {
    listLength: {
      type: Number,
      default: 0
    }
  },
  data() {
    var checkDeliveryTime = (rule, value, callback) => {
      if (this.timeState) {
        if (this.ruleForm.deliveryTime == null) {
          return callback(new Error(this.$t("projectV2.limitTimeNullText")));
        } else if (new Date(this.ruleForm.deliveryTime) < new Date()) {
          return callback(new Error(this.$t("projectV2.limitTimeErrorText")));
        } else {
          callback();
        }
      }
    };
    var checkName = (rule, value, callback) => {
      if (
        this.ruleForm.name == null ||
        this.ruleForm.name.split(" ").join("").length == 0
      ) {
        return callback(new Error(this.$t("jobManagementV2.enterobName")));
      } else if (value.length < 2) {
        return callback(
          new Error(this.$t("jobManagementV2.jobNameLengthValue1"))
        );
      } else if (value.length > 30) {
        return callback(
          new Error(this.$t("jobManagementV2.jobNameLengthValue2"))
        );
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        },
      },
      fileReplace: 0, //是否替换文件 0为不替换 1为替换
      areaHidden: false,
      dialogVisible: false,
      fileList: [],
      domin:"",
      ruleForm: {
        name: "",
        sourceLang: "",
        targetLang: "",
        domainCode: "",
        deliveryTime: null,
      },
      mtLangReqVo: {},
      formData: new FormData(),
      transModel: 1,
      sourceLangNameOpt: [], //源语言
      targetLangNameOpt: [], //目标语言
      domainList: [], //领域
      host: "",
      id: "", //项目id
      fileId: "",
      fileInfo: {},
      finishTaskNumber: 0, //学生完成情况
      unFinishTaskNumber: 0, //学生未完成情况
      disabledConditions: false,
      rules: {
        name: [{ validator: checkName, trigger: ["change", "blur"], required: true }],
        deliverytime: [
          { validator: checkDeliveryTime, trigger: ["change", "blur"], required: true },
        ],
      },
      deadline: null,
      timeState: true,
    };
  },
  created() { },
  updated() { },
  computed: {
    listContent() {
      return this.listLength
    }
  },
  mounted() {
    this.bus.$on("params", (val) => {
      this.dialogVisible = val.dialogVisible;
      this.id = val.id;
      this.fileId = val.fileId;
      this.unFinishTaskNumber = val.unFinishTaskNumber;
      this.finishTaskNumber = val.finishTaskNumber;
     
    });
    this.queryDomain();
    this.querySourceLangName();
  },
  destroyed() {
    this.bus.$off("params");
  },
  methods: {
    disableOption() {
      if (
        new Date() > new Date(this.ruleForm.deliveryTime) &&
        (this.unFinishTaskNumber !== null || this.finishTaskNumber != 0)
      ) {
        this.disabledConditions = true;
      } else {
        this.disabledConditions = false;
      }
    },
    // 自定义文件上传开始
    uploadSectionFile(param) {
      let self = this;

      // 获得上传签名
      getUploadSign()
        .then(({ result }) => {
          // 上传地址
          this.host = result.host;
          let re = /([^\.\/\\]+)\.([a-z]+)$/i;
          let resultArr = re.exec(param.file.name);
          // 文件类型
          let type = resultArr[2].toLocaleLowerCase();
          let para = {
            ...result,
            key: `${result.keyPrefix}.${type}`,
            file: param.file,
          };
          Reflect.deleteProperty(para, 'keyPrefix');
          Reflect.deleteProperty(para, 'host');

          self.formData = new FormData();
          Object.keys(para).forEach(function (key) {
            self.formData.append(key, para[key]);
          });

          this.getFileHost(param);
        })
        .catch(() => {
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
          this.$message({
            message: this.$t("jobManagementV2.uploadFileError"),
            type: "warning",
          });
        });
    },
    getFileHost(param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: (progressEvent) => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        },
      };
      axios
        .post(FileController, self.formData, config)
        .then((resp) => {
          let { result } = resp.data;
          setTimeout(() => {
            this.areaHidden = false;
          }, 500);
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.path = result.fileName;
              item.isLoading = 1;
            }
          });
        })
        .catch(() => {
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
        });
    },
    uploadChange(file) {
      this.fileInfo = {
        name: file.name,
        fileSize: file.size,
        sourceWordNum: "-",
        sentCount: "-",
      };
      this.fileList.push({
        ...file,
        path: "",
        isLoading: null,
      });
    },
    beforeUploadFile(file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > 20;

      let typeFlag = this.$supportFileSuffixes(type).isSupport;

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$supportFileSuffixes().tip]));
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("jobManagementV2.uploadError"),
          type: "warning",
        });
        this.deleteJob();
        return false;
      }

      this.fileList.slice(0, -1).forEach((item) => {
        if (item.name == file.name) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("jobManagementV2.uploadErrorV2"),
            type: "warning",
          });
          this.fileList.pop();
          file.obp = true;
          return false;
        }
      });

      if (isLt20M) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("jobManagementV2.uploadErrorV3"),
          type: "warning",
        });
        file.obp = true;
        return false;
      }
      return true;
    },
    handleExceed() {
      this.$message.closeAll();
      this.$message({
        message: this.$t("jobManagementV2.uploadErrorV4"),
        type: "warning",
      });
    },
    // 上传进度条显示
    format(percentage) {
      return percentage === 100 ? "已完成" : `${percentage}%`;
    },
    // 移除文件
    deleteJob() {
      if ((this.finishTaskNumber || this.unFinishTaskNumber)) {
        this.$message.closeAll()
        this.$message.warning(this.$t("jobManagementV2.homeworkAllocation"));
      }
      else if (this.listContent !== 0) {
        this.$message.closeAll()
        this.$message.warning(this.$t("jobManagementV2.homeworkAllocation"));
      }
      else if (new Date() > this.ruleForm.deliveryTime) {
        this.$message.closeAll()
        this.$message.warning(this.$t("jobManagementV2.homeworkOver"));
      } else {
        this.fileList.splice(0, 1);
        this.areaHidden = true;
        this.fileReplace = 1;
      }
    },
    // 查询所有语言
    querySourceLangName() {
      queryLanguageList({ type: 1 }).then(({ result }) => {
        this.sourceLangNameOpt = result;
      });
    },
    // 获取领域
    queryDomain() {
      queryDomainList().then(({ result }) => {
        this.domainList = result;
      });
    },
    createJob(formName) {
      if (new Date(this.ruleForm.deliveryTime) < new Date()) {
        if (this.deadline < new Date()) {
          this.$message.closeAll();
          this.$message.warning(this.$t('jobManagementV2.assignmentDue'));
        }
        return false
      }
      let self = this;
      this.$refs[formName].validateField("name", (valid) => {
        if (!valid) {
          if (this.fileReplace === 1 && !this.fileList.length) {
            this.$message.warning(this.$t("jobManagementV2.uploadErrorV5"));
            return;
          }
          let params;
          if (this.fileReplace === 1) {
            // 上传文件列表
            let obj = {};
            this.fileList.forEach((item) => {
              obj = {
                name: item.name,
                filePath: item.path,
                fileSuffix: /([^\.\/\\]+)\.([a-z]+)$/i.exec(item.name)[2],
                transModel: 0,
                platformType: this.$platformType,
                targetLang: this.ruleForm.targetLang,
                sourceLang: this.ruleForm.sourceLang,
                domainCode: this.ruleForm.domainCode,
              };
            });
            params = {
              transFile: obj,
              id: this.id,
              // deliveryTime: this.dateFormat(this.ruleForm.deliveryTime),
              deliveryTime: this.ruleForm.deliveryTime,
              name: this.ruleForm.name,
            };
            let sourceName = this.ruleForm.sourceLangName;
            let targetName = this.ruleForm.targetLangName;
            let langDesc = sourceName + ">" + targetName;
            params.transFile.langDesc = langDesc;
          } else {
            params = {
              id: this.id,
              // deliveryTime: this.dateFormat(this.ruleForm.deliveryTime),
              deliveryTime: this.ruleForm.deliveryTime,
              name: this.ruleForm.name,
            };
          }
          updateProject(params).then(({ success, errorDesc, status }) => {
            if (success && status == 200) {
              this.$emit('getjobInfo')
              this.$message.success(this.$t("jobManagementV2.editedSuccessfully"));
              this.dialogVisible = false;
              if (this.$parent.queryJob) {
                this.$parent.queryJob(
                  this.$parent.pageDto.page,
                  this.$parent.pageDto.sort
                );
              } else {
                this.$parent.queryStudentPro();
                this.$parent.queryProjectInfo();
                this.$parent.queryFileInfo();
              }
            } else {
              this.$message.closeAll();
              this.$message.warning(errorDesc);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 根据id查询项目信息
    queryJobInfo() {
      queryProjectTermMemoryList({ id: this.id }).then(({ result }) => {
        this.ruleForm = {
          name: result.name,
          sourceLang: result.sourceLang,
          targetLang: result.targetLang,
          domainCode: result.domainCode,
          deliveryTime: result.deliveryTime + ':00',
          sourceLangName: result.sourceLangName,
          targetLangName: result.targetLangName,
        };
        this.deadline = new Date(result.deliveryTime + ':00');
        if (this.deadline < new Date()) {
          this.timeState = false
        }
      });
    },
    closeDialog() {
      this.id = null;
      this.areaHidden = false;
      this.disabledConditions = false;
      this.fileReplace = 0;
    },
    // 查询文件信息
    getFile() {
      queryFile({ id: this.id }).then(({ result }) => {
        this.fileInfo = result[0];
      });
    },
    async getTargetLang(val) {
      let params = {
        type: 2,
        sourceLang: val
      }
      const res = await queryLanguageList(params)
      if (res.status == 200 && res.success) {
        this.targetLangNameOpt = res.result
      }
    },
  },
  watch: {
    id: {
      handler(val) {
        if (val) {
          this.queryJobInfo();
          this.getFile();
          this.getTargetLang();
          this.timeState = true
        }
      },
    },
    ruleForm: {
      handler(val) {
        this.disableOption();
        this.getTargetLang(val.sourceLang)
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
